import {
  saveAddLeadActions,
  RESET_ADD_LEAD_ID,
  CourseLoanActions,
  BUCKET_CHANGE,
} from "./action";

const initialState = {
  // LeadMasterListData: {},
  saveAddLead: {},
  courseType: {},
  bucketType: "INCOMPLETE",
  error: "",
};

const getAllAddLeadDataReducer = (state = initialState, action) => {
  switch (action.type) {
    // case LeadMasterListActions.LEAD_MASTER_LIST_SUCCESS:
    //   return {
    //     ...state,
    //     LeadMasterListData: action.payload,
    //     error: "",
    //   };
    // case LeadMasterListActions.LEAD_MASTER_LIST_ERROR:
    //   return {
    //     ...state,
    //     LeadMasterListData: {},
    //     error: action.payload,
    //   };

    case saveAddLeadActions.SAVE_ADD_LEAD_SUCCESS:
      return {
        ...state,
        saveAddLead: action.payload.data,
        error: "",
      };
    case saveAddLeadActions.SAVE_ADD_LEAD_ERROR:
      return {
        ...state,
        saveAddLead: {},
        error: action.payload,
      };
    case RESET_ADD_LEAD_ID:
      return {
        ...state,
        saveAddLead: {
          ...state.saveAddLead,
          Id: null,
        },
      };
    case CourseLoanActions.COURSE_TYPE_NAME_SUCCESS:
      return {
        ...state,
        courseType: action.payload,
      };
    case BUCKET_CHANGE:
      return {
        ...state,
        bucketType: action.payload,
      };

    default:
      return state;
  }
};

export default getAllAddLeadDataReducer;
